<template>
	<v-fade-transition
		:hide-on-leave="hideOnLeave"
	>
		<slot></slot>
	</v-fade-transition>
</template>

<script>
export default {
	name: 'KFadeTransition',
	props: {
		hideOnLeave: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
